import { Injectable, inject } from "@angular/core";
import { IframeMessagesService } from "../iframe-messages-service/iframe-messages.service";

export interface DashboardUpdateMetadata {
    documentMetadata: DashboardDocumentMetadata;
    group1Id?: string;
    group2Id?: string;
}

export interface DashboardDocumentMetadata {
    documentId: string;
    returnId: string;
    assignees?: DashboardReturnAssignees;
    status?: string;
}

export interface DashboardReturnAssignees {
    reviewerUserId?: string;
    preparerUserId?: string;
}

@Injectable({
    providedIn: "root",
})
export class IfirmTaxDocumentService {
    private iframeMessagesService = inject(IframeMessagesService);

    constructor() {}

    async updateDocument(metadata: DashboardUpdateMetadata[]) {
        const result = await this.iframeMessagesService.postMessageResp("updateiFirmTaxDocument", metadata, "iFirmTaxDocumentUpdated");
        if (result.status === "success") {
            return result.response;
        }
        throw new Error("Failed to update document");
    }
}
